import React, { Component } from "react";
import ReactInputMask from "react-input-mask";
import FilterSelectAddFilterButton from "./FilterSelectAddFilterButton";
import { isPropsForLogicalOperator } from "./LogicalOperatorsOptions";
import moment from "moment";

/**
 * Types supported for periods. Each value is a Moment Manipulate shorthand
 */
const PeriodOptionsEnum = {
  Hours: "h",
  Days: "d",
  Weeks: "w",
  // M === Months, m === Minutes
  Months: "M",
};

/**
 * Allow the user to Input values related to In The Last of minutes, hours, seconds
 */
class LogicalOperatorInTheLastView extends Component {
  constructor(props) {
    super();
    this.state = isPropsForLogicalOperator(props)
      ? props.logicalOperator.value
      : {
          value: "",
          period: "",
          calculatedDate: "",
        };
  }

  onChange = (event) => {
    event.preventDefault();
    this.setState(
      {
        [event.target.id]: event.target.value,
      },
      () => {
        const calculatedDate = moment(new Date()).subtract(
          this.state.value,
          this.state.period
        );
        this.setState({
          calculatedDate,
        });
      }
    );
  };

  /**
   * Set the value in the current Filter
   */
  onApplyFilter = () => {
    this.props.onApplyFilter(this.state);
  };

  render() {
    return (
      <>
        <div className="p-2 filter-container">
          <div className="form-row">
            <div className="col-3">
              <ReactInputMask
                mask="9999"
                maskChar=""
                type="text"
                id="value"
                value={this.state.value}
                className="form-control form-control-sm"
                placeholder="Value"
                onChange={this.onChange}
              />
            </div>
            <div className="col-9">
              <select
                id="period"
                className="form-control form-control-sm"
                value={this.state.period}
                onChange={this.onChange}
              >
                <option>Select a period</option>
                {Object.keys(PeriodOptionsEnum).map((po) => (
                  <option key={po} value={po}>
                    {po}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <FilterSelectAddFilterButton
          disabled={
            this.state.value.trim().length === 0 ||
            this.state.period.trim().length === 0
          }
          onClick={this.onApplyFilter}
        />
      </>
    );
  }
}

export default LogicalOperatorInTheLastView;
